/* eslint-disable */
import {
  Customer_Provider,
  customer_ProviderFromJSON,
  customer_ProviderToJSON,
} from "../../../../../api/customers/resources";

export const protobufPackage = "store.api.misc.eventrecord";

export interface AddFbEventRequest {
  /** Required. id */
  id: string;
  /** Required. 觸發事件 */
  eventName: string;
  /** Required. content type. */
  contentType: string;
  /** Required. 商品編號 */
  contentIds: string[];
  /** Optional. 金額(台幣) */
  value: string;
  /** Required. location href */
  sourceUrl: string;
  /** Optional. 會員帳號類型 */
  provider: Customer_Provider;
}

function createBaseAddFbEventRequest(): AddFbEventRequest {
  return { id: "", eventName: "", contentType: "", contentIds: [], value: "", sourceUrl: "", provider: 0 };
}

export const AddFbEventRequest = {
  fromJSON(object: any): AddFbEventRequest {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      eventName: isSet(object.eventName) ? String(object.eventName) : "",
      contentType: isSet(object.contentType) ? String(object.contentType) : "",
      contentIds: Array.isArray(object?.contentIds) ? object.contentIds.map((e: any) => String(e)) : [],
      value: isSet(object.value) ? String(object.value) : "",
      sourceUrl: isSet(object.sourceUrl) ? String(object.sourceUrl) : "",
      provider: isSet(object.provider) ? customer_ProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: AddFbEventRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.eventName !== undefined && (obj.eventName = message.eventName);
    message.contentType !== undefined && (obj.contentType = message.contentType);
    if (message.contentIds) {
      obj.contentIds = message.contentIds.map((e) => e);
    } else {
      obj.contentIds = [];
    }
    message.value !== undefined && (obj.value = message.value);
    message.sourceUrl !== undefined && (obj.sourceUrl = message.sourceUrl);
    message.provider !== undefined && (obj.provider = customer_ProviderToJSON(message.provider));
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFbEventRequest>, I>>(base?: I): AddFbEventRequest {
    return AddFbEventRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<AddFbEventRequest>, I>>(object: I): AddFbEventRequest {
    const message = createBaseAddFbEventRequest();
    message.id = object.id ?? "";
    message.eventName = object.eventName ?? "";
    message.contentType = object.contentType ?? "";
    message.contentIds = object.contentIds?.map((e) => e) || [];
    message.value = object.value ?? "";
    message.sourceUrl = object.sourceUrl ?? "";
    message.provider = object.provider ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
